export default __webpack_public_path__ + "static/media/points_image.281695ff.jpg";